import { EventEmitter } from '@angular/core';
import { REPORT_ORIENTATION_TO_PAGE_DIMENSIONS, TEARSHEET_PAGE_SIZE_CONVERSION_FACTOR, } from 'CustomPDFReportsApp/ts/apps/custom-pdf-report-builder-app/constants';
import { CustomPDFReportOrientation } from 'CustomPDFReportsApp/ts/enums/custom-pdf-report-orientation.enum';
import * as i0 from "@angular/core";
import * as i1 from "../../../../../../../../../../ycharts/static/ts/features/components/modals/modal-base/components/modal-base.component";
import * as i2 from "../../../../../../../../../../ycharts/static/ts/features/components/modals/modal-base/components/simple-modal-header.component";
const _c0 = () => [];
const _forTrack0 = ($index, $item) => $item.module_id + $item.module_type;
function PreviewSectionsModalComponent_Conditional_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 3);
    i0.ɵɵelement(1, "div", 5);
    i0.ɵɵelementEnd();
} }
function PreviewSectionsModalComponent_Conditional_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 4);
    i0.ɵɵtext(1, "Unable to load preview. Please try again.");
    i0.ɵɵelementEnd();
} }
function PreviewSectionsModalComponent_Conditional_5_For_1_For_4_Conditional_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 11);
} if (rf & 2) {
    const module_r1 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("textContent", module_r1.error);
} }
function PreviewSectionsModalComponent_Conditional_5_For_1_For_4_Conditional_2_Template(rf, ctx) { if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "img", 13);
    i0.ɵɵlistener("error", function PreviewSectionsModalComponent_Conditional_5_For_1_For_4_Conditional_2_Template_img_error_0_listener() { i0.ɵɵrestoreView(_r2); const module_r1 = i0.ɵɵnextContext().$implicit; const ctx_r2 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r2.onImageLoadError(module_r1)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const module_r1 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("src", module_r1.imageUrls == null ? null : module_r1.imageUrls[0], i0.ɵɵsanitizeUrl);
} }
function PreviewSectionsModalComponent_Conditional_5_For_1_For_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 10);
    i0.ɵɵconditionalCreate(1, PreviewSectionsModalComponent_Conditional_5_For_1_For_4_Conditional_1_Template, 1, 1, "div", 11)(2, PreviewSectionsModalComponent_Conditional_5_For_1_For_4_Conditional_2_Template, 1, 1, "img", 12);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const module_r1 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵstyleProp("top", ctx_r2.topPercent(module_r1), "%")("left", ctx_r2.leftPercent(module_r1), "%")("width", ctx_r2.widthPercent(module_r1), "%")("height", ctx_r2.heightPercent(module_r1), "%");
    i0.ɵɵadvance();
    i0.ɵɵconditional(module_r1.error ? 1 : 2);
} }
function PreviewSectionsModalComponent_Conditional_5_For_1_For_6_For_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 7);
    i0.ɵɵelement(1, "div")(2, "img", 15);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const continuationImage_r4 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext(4);
    i0.ɵɵstyleProp("max-width", ctx_r2.isLandscape ? 692 : 534, "px");
    i0.ɵɵadvance();
    i0.ɵɵstyleProp("padding-top", ctx_r2.pageSpacerPaddingTopPercent, "%");
    i0.ɵɵadvance();
    i0.ɵɵproperty("src", continuationImage_r4, i0.ɵɵsanitizeUrl);
} }
function PreviewSectionsModalComponent_Conditional_5_For_1_For_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵrepeaterCreate(0, PreviewSectionsModalComponent_Conditional_5_For_1_For_6_For_1_Template, 3, 5, "div", 14, i0.ɵɵrepeaterTrackByIndex);
} if (rf & 2) {
    const module_r5 = ctx.$implicit;
    i0.ɵɵrepeater((module_r5.imageUrls ?? i0.ɵɵpureFunction0(0, _c0)).slice(1));
} }
function PreviewSectionsModalComponent_Conditional_5_For_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 7);
    i0.ɵɵelement(1, "div");
    i0.ɵɵelementStart(2, "div", 8);
    i0.ɵɵrepeaterCreate(3, PreviewSectionsModalComponent_Conditional_5_For_1_For_4_Template, 3, 9, "div", 9, _forTrack0);
    i0.ɵɵelementEnd()();
    i0.ɵɵrepeaterCreate(5, PreviewSectionsModalComponent_Conditional_5_For_1_For_6_Template, 2, 1, null, null, _forTrack0);
} if (rf & 2) {
    const page_r6 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵstyleProp("max-width", ctx_r2.isLandscape ? 692 : 534, "px");
    i0.ɵɵadvance();
    i0.ɵɵstyleProp("padding-top", ctx_r2.pageSpacerPaddingTopPercent, "%");
    i0.ɵɵadvance(2);
    i0.ɵɵrepeater(ctx_r2.modulesForPage(page_r6));
    i0.ɵɵadvance(2);
    i0.ɵɵrepeater(ctx_r2.modulesForPage(page_r6));
} }
function PreviewSectionsModalComponent_Conditional_5_Conditional_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 6);
    i0.ɵɵtext(1, "No sections selected.");
    i0.ɵɵelementEnd();
} }
function PreviewSectionsModalComponent_Conditional_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵrepeaterCreate(0, PreviewSectionsModalComponent_Conditional_5_For_1_Template, 7, 4, null, null, i0.ɵɵrepeaterTrackByIdentity);
    i0.ɵɵconditionalCreate(2, PreviewSectionsModalComponent_Conditional_5_Conditional_2_Template, 2, 0, "div", 6);
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵrepeater(ctx_r2.pageNumbers);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(!ctx_r2.pageNumbers.length ? 2 : -1);
} }
export class PreviewSectionsModalComponent {
    constructor() {
        this.open = false;
        this.loading = false;
        this.error = false;
        this.modules = [];
        this.reportOrientation = CustomPDFReportOrientation.PORTRAIT;
        this.closeModalHandler = new EventEmitter();
    }
    get isLandscape() {
        return this.reportOrientation === CustomPDFReportOrientation.LANDSCAPE;
    }
    get pageDimensions() {
        return REPORT_ORIENTATION_TO_PAGE_DIMENSIONS[this.reportOrientation];
    }
    // `.pdf-page`'s own height comes from a flex `::before` trick that needs an in-flow sibling this
    // preview doesn't have (its modules are absolutely positioned) -- use a plain padding-top spacer
    // instead, which only depends on normal flow.
    get pageSpacerPaddingTopPercent() {
        return this.isLandscape ? (8.5 / 11) * 100 : (11 / 8.5) * 100;
    }
    get pageNumbers() {
        return [...new Set(this.modules.map((module) => module.page))].sort((a, b) => a - b);
    }
    modulesForPage(page) {
        return this.modules.filter((module) => module.page === page);
    }
    // Percentages of the page's total grid columns/rows, so modules are absolutely positioned without
    // depending on GridStack's JS-driven inline styles (this preview never initializes GridStack).
    leftPercent(module) {
        return ((module.x_coordinate / this.pageDimensions.x_coordinate_conversion_factor / this.pageDimensions.width) * 100);
    }
    topPercent(module) {
        return ((module.y_coordinate / this.pageDimensions.y_coordinate_conversion_factor / this.pageDimensions.height) *
            100);
    }
    widthPercent(module) {
        return ((module.module_width / this.pageDimensions.x_coordinate_conversion_factor / this.pageDimensions.width) * 100);
    }
    heightPercent(module) {
        return ((module.module_size /
            TEARSHEET_PAGE_SIZE_CONVERSION_FACTOR /
            this.pageDimensions.y_coordinate_conversion_factor /
            this.pageDimensions.height) *
            100);
    }
    close() {
        this.closeModalHandler.emit();
    }
    // Non-live modules render their static/uploaded image URL directly, with no request this
    // component observes -- without this, a broken URL would silently leave a blank image tile.
    onImageLoadError(module) {
        module.error = 'Unable to load preview.'; // eslint-disable-line no-param-reassign
    }
}
PreviewSectionsModalComponent.ɵfac = function PreviewSectionsModalComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || PreviewSectionsModalComponent)(); };
PreviewSectionsModalComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: PreviewSectionsModalComponent, selectors: [["ycn-preview-sections-modal"]], inputs: { open: "open", loading: "loading", error: "error", modules: "modules", reportOrientation: "reportOrientation" }, outputs: { closeModalHandler: "closeModalHandler" }, standalone: false, decls: 6, vars: 5, consts: [[3, "closeModalHandler", "modalBaseClass", "extraModalClasses", "open"], [3, "closeModalHandler", "header"], [1, "modal-body"], [1, "text-center", "p-40"], [1, "text-center", "text-red", "p-40"], [1, "loader-spinner-context", "loader-md"], [1, "text-center", "text-gray-50", "p-40"], [1, "mb-20", 2, "position", "relative", "width", "100%", "margin", "0 auto", "border", "1px solid #d0d0d0", "box-shadow", "0 2px 4px rgba(0, 0, 0, .25)", "background", "white"], [2, "position", "absolute", "top", "0", "left", "0", "right", "0", "bottom", "0"], [2, "position", "absolute", "overflow", "hidden", 3, "top", "left", "width", "height"], [2, "position", "absolute", "overflow", "hidden"], [1, "text-red", "text-xs", "p-8", 3, "textContent"], ["alt", "Module preview", 1, "object-fit-contain", "d-block", 3, "src"], ["alt", "Module preview", 1, "object-fit-contain", "d-block", 3, "error", "src"], [1, "mb-20", 2, "position", "relative", "width", "100%", "margin", "0 auto", "border", "1px solid #d0d0d0", "box-shadow", "0 2px 4px rgba(0, 0, 0, .25)", "background", "white", 3, "max-width"], ["alt", "Module preview continued", 1, "object-fit-contain", "d-block", 2, "position", "absolute", "top", "0", "left", "0", 3, "src"]], template: function PreviewSectionsModalComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "ycn-modal-base", 0);
        i0.ɵɵlistener("closeModalHandler", function PreviewSectionsModalComponent_Template_ycn_modal_base_closeModalHandler_0_listener() { return ctx.close(); });
        i0.ɵɵelementStart(1, "ycn-simple-modal-header", 1);
        i0.ɵɵlistener("closeModalHandler", function PreviewSectionsModalComponent_Template_ycn_simple_modal_header_closeModalHandler_1_listener() { return ctx.close(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(2, "div", 2);
        i0.ɵɵconditionalCreate(3, PreviewSectionsModalComponent_Conditional_3_Template, 2, 0, "div", 3)(4, PreviewSectionsModalComponent_Conditional_4_Template, 2, 0, "div", 4)(5, PreviewSectionsModalComponent_Conditional_5_Template, 3, 1);
        i0.ɵɵelementEnd()();
    } if (rf & 2) {
        i0.ɵɵproperty("modalBaseClass", "modal-fix-scroll")("extraModalClasses", "modal-lg")("open", ctx.open);
        i0.ɵɵadvance();
        i0.ɵɵproperty("header", "Preview");
        i0.ɵɵadvance(2);
        i0.ɵɵconditional(ctx.loading ? 3 : ctx.error ? 4 : 5);
    } }, dependencies: [i1.ModalBaseComponent, i2.SimpleModalHeaderComponent], encapsulation: 2 });
